const al = {
 "studio": "Resource Studio",
 "studioSub": "Buscar → Previsualizar → Adaptar → Asignar. Conjunto de prueba: {n} recursos.",
 "search": "Buscar recursos",
 "all": "Todos",
 "language": "Idioma",
 "level": "Nivel",
 "type": "Tipo",
 "eligibility": "Disponible en",
 "why": "Por qué encaja",
 "reg": {"label": "Registro", "unspecified": "Sin especificar", "v": {"formal": "Formal", "informal": "Informal", "mixed": "Mixto", "neutral_na": "Neutro / no aplica"}, "edit": "Editar", "choose": "Elegir registro", "notePh": "Nota breve (opcional)", "notePhMixed": "¿Quién usa qué forma? (obligatoria si es mixto)", "noteNeeded": "Un registro mixto necesita una nota breve.", "saved": "Registro guardado. Texto de la actividad sin cambios."},
 "teacherOnly": "Solo docentes",
 "answerKey": "Solucionario",
 "rubric": "Rúbrica",
 "notes": "Notas para docentes",
 "preview": "Vista del alumno",
 "adapt": "Adaptar",
 "assign": "Asignar a la clase",
 "assigned": "Asignado a tu clase.",
 "adapted": "Tu copia adaptada se guardó. El original no cambia.",
 "titleLabel": "Título",
 "instructionsLabel": "Instrucciones para el alumno",
 "save": "Guardar copia",
 "cancel": "Cancelar",
 "noResults": "Ningún recurso coincide con estos filtros.",
 "previewNote": "Contenido de prueba — no forma parte de la futura biblioteca",
 "lab": "Discovery Lab",
 "labSub": "Descubre → prueba → entiende → usa. Unas pocas actividades para explorar.",
 "secTry": "Prueba esto",
 "secPattern": "Explora un patrón",
 "secSolve": "Resuelve algo",
 "secRead": "Lee y descubre",
 "check": "Comprobar",
 "score": "{c} de {t} correctas",
 "tryAgain": "Intentar de nuevo",
 "done": "Hecho",
 "know": "Lo sé",
 "again": "Otra vez",
 "flip": "Toca para girar",
 "keep": "Guardar estas para mi práctica personal",
 "kept": "Guardado en tu banco de vocabulario.",
 "cantKeep": "El idioma de este conjunto no es uno de tus idiomas de aprendizaje, así que no se puede guardar.",
 "practiceDone": "Práctica guardada para tu clase.",
 "results": "Resultados de la clase",
 "completed": "Completado",
 "attempted": "Empezado",
 "notAttempted": "Sin empezar",
 "classResources": "Recursos de la clase",
 "open": "Abrir",
 "minutes": "{n} min",
 "failed": "Algo salió mal. Inténtalo de nuevo.",
 "close": "Cerrar",
 "cardOf": "{i} / {n}",
 "pickClass": "Elige una clase",
 "mine": "Mis adaptaciones",
 "explored": "Explorado",
 "fam": {
  "grammar": "Gramática",
  "worksheet": "Ficha",
  "memory": "Tarjetas",
  "game": "Puzle",
  "form": "Formulario",
  "document": "Documento real",
  "speaking": "Expresión oral",
  "reading": "Lectura y cultura",
  "assessment": "Evaluación",
  "data": "Reto de datos"
 },
 "elig": {
  "public": "Público",
  "pro": "Pro",
  "education": "Educación"
 }
};
al.p = {
 "sev": {"low": "Baja", "medium": "Media", "high": "Alta"},
 "area": {"language_accuracy": "Corrección lingüística", "naturalness": "Naturalidad", "cefr_fit": "Nivel MCER", "answer_key": "Clave", "instructions": "Instrucciones", "pedagogy": "Pedagogía", "culture_stereotypes": "Cultura y estereotipos", "duplication": "Duplicación", "formatting_script": "Formato y escritura", "provenance": "Procedencia", "objective_alignment": "Alineación con el objetivo", "teacher_learner_match": "Docente/alumno coherente"},
 "edited": "editado",
 "precheck": "Prerrevisión IA",
 "precheckRun": "Ejecutar prerrevisión IA",
 "precheckRerun": "Repetir",
 "precheckNone": "Aún sin prerrevisión.",
 "precheckStale": "versión anterior",
 "corrections": "{n} correcciones propuestas (no aplicadas)",
 "precheckAdvisory": "Solo orientativa: nunca aprueba ni cambia el recurso.",
 "pv": {"pass": "IA: bien", "revise": "IA: revisar", "attention": "IA: requiere atención humana"},
 "badJson": "El JSON no es válido.",
 "contentSaved": "Contenido guardado; lo anterior queda en el registro.",
 "editContent": "Editar contenido",
 "editTrail": "Cada cambio se registra con el contenido anterior.",
 "history": "Versiones",
 "startRevision": "Iniciar revisión",
 "revisionStarted": "Borrador v{v} creado. La versión aprobada sigue activa.",
 "histAssign": "{n} asignaciones conservan su versión congelada.",
 "confirmElig": "He revisado la disponibilidad: {e}",
 "confirmEligFirst": "Confirma primero la disponibilidad.",
 "objective": "Objetivo",
 "provenance": "Procedencia",
 "wave": "Filtrar oleada",
 "booklet": "Cuadernillo",
 "summary": "PDF resumen",
 "showMore": "Mostrar {n} más",
 "showLess": "Mostrar menos",
 "checklistIncomplete": "Marca primero todos los puntos de la lista.",
 "across": "Horizontales",
 "down": "Verticales",
 "clueListNote": "Escribe cada respuesta junto a su número. El número entre paréntesis indica las letras.",
 "again": "Practicar otra vez",
 "exportVersion": "Versión",
 "print": "Imprimir",
 "export": "Exportar",
 "theme": "Tema",
 "grammar": "Gramática",
 "vocab": "Vocabulario",
 "function": "Función comunicativa",
 "duration": "Minutos",
 "teacherInstr": "Instrucciones para la IA (opcional)",
 "canonical": "Borrador canónico de GetFluentLoop (pasa a revisión)",
 "draftSaved": "Borrador guardado. Es privado hasta que lo marques como listo.",
 "draftNote": "Borrador IA: revisa idioma, nivel y respuestas antes de guardar.",
 "fromFile": "Creado a partir de",
 "saveDraft": "Guardar borrador",
 "uploaded": "Archivo subido a tus archivos.",
 "aiNote": "Los borradores IA siempre empiezan como privados. Nada se publica ni asigna automáticamente.",
 "uploadNote": "Sube un PDF, Word, texto, CSV o Excel. El original no cambia; la actividad es un borrador privado aparte.",
 "uploadedAs": "guardado como recurso.",
 "useAsResource": "Usar como recurso ✓",
 "orCreate": "o crea una actividad a partir de él:",
 "generating": "Generando…",
 "generate": "Generar borrador",
 "createFromFile": "Crear una actividad a partir de esto",
 "suggestedBy": "Sugerido por un docente",
 "checklist": "Lista de calidad",
 "checklistNote": "Revisión humana. Marca cada punto; las dudas deben resolverse antes.",
 "reviewNote": "Nota de revisión / aprobación (interna)",
 "reviewSub": "Cola editorial del contenido canónico de GetFluentLoop. Las notas son internas.",
 "reviewEmpty": "No hay nada aquí.",
 "packName": "Nombre del paquete",
 "packCreated": "Paquete creado.",
 "packsSub": "Los paquetes agrupan recursos, misiones y archivos. Los personales son privados salvo que un admin escolar los comparta.",
 "createPack": "Crear paquete",
 "packsEmpty": "Aún no hay paquetes.",
 "school": "Escuela",
 "private": "Privado",
 "packSaved": "Guardado como paquete.",
 "subSub": "Crea una clase de sustitución solo con recursos aprobados, sin IA.",
 "themeOptional": "Tema (opcional)",
 "buildLesson": "Crear clase",
 "lessonTotal": "Clase: {n} min (pedido {r})",
 "mission": "misión",
 "missing": "Aún no hay recurso aprobado",
 "subNote": "Imprime cada parte desde Resource Studio. Las claves son solo para docentes.",
 "savePack": "Guardar como paquete",
 "linked": "Añadido a la misión.",
 "useInMission": "Usar en una misión",
 "startMission": "Empezar un borrador de misión",
 "orExisting": "o añádelo a una de tus misiones guardadas:",
 "noMissions": "No hay misiones guardadas en este idioma.",
 "attach": "Añadir",
 "addedToPack": "Añadido al paquete.",
 "choosePack": "Elige un paquete",
 "addToPack": "Añadir al paquete",
 "readyDone": "Listo para asignar.",
 "markReady": "Marcar como listo",
 "unshared": "Ya no se comparte.",
 "shared": "Compartido con tu escuela.",
 "unshare": "Dejar de compartir",
 "share": "Compartir con la escuela",
 "suggest": "Sugerir para la biblioteca GetFluentLoop",
 "draftPrivate": "Borrador privado: solo tú lo ves. Márcalo como listo para asignarlo.",
 "suggestNote": "Se crea una copia aparte para los editores de GetFluentLoop. Tu versión no cambia.",
 "rights": "Tus derechos para compartirlo",
 "suggestNotePh": "Algo que deban saber los editores (opcional)",
 "suggested": "Enviado a la cola de revisión de GetFluentLoop.",
 "send": "Enviar",
 "denied": "Resource Studio es para docentes verificados.",
 "draftNoAssign": "Márcalo como listo antes de asignarlo.",
 "schoolShared": "Compartido en mi escuela",
 "missionResources": "Recursos de esta misión",
 "attachResources": "Añadir recursos (mismo idioma)",
 "noCompatible": "No hay recursos listos en este idioma.",
 "previewCombined": "Vista previa con recursos",
 "pickMissionFor": "Elige una misión para combinar con {id} ({lang}) y añádelo al asignar.",
 "ver": {
  "learner": "Hoja del alumno",
  "teacher": "Versión docente",
  "answer_key": "Clave de respuestas",
  "teacher_guide": "Guía docente"
 },
 "grp": {
  "individual": "Individual",
  "pairs": "Parejas",
  "groups": "Grupos",
  "whole_class": "Toda la clase"
 },
 "mode": {
  "ai": "Borrador IA",
  "upload": "Desde un archivo"
 },
 "out": {
  "worksheet": "Hoja de trabajo",
  "grammar_discovery": "Descubrir gramática",
  "flashcards": "Tarjetas",
  "crossword": "Crucigrama / puzle",
  "interactive_form": "Formulario interactivo",
  "reading": "Lectura",
  "speaking_cards": "Tarjetas de conversación",
  "exit_ticket": "Ticket de salida",
  "data_challenge": "Reto de datos"
 },
 "st": {
  "draft": "Borrador",
  "reviewed": "Revisado",
  "approved": "Aprobado",
  "retired": "Retirado",
  "superseded": "Sustituido",
  "teacher_ready": "Listo"
 },
 "cv": {
  "pass": "Bien",
  "concern": "Duda",
  "na": "N/A"
 },
 "do": {
  "reviewed": "Marcar revisado",
  "approved": "Aprobar",
  "draft": "Devolver a borrador",
  "retired": "Retirar"
 },
 "pp": {
  "warmups": "Calentamientos de 10 min",
  "speaking": "Semana de conversación",
  "revision": "Repaso de examen",
  "reading": "Semana de lectura",
  "grammar": "Descubrir gramática",
  "substitute": "Docente sustituto",
  "other": "Otro"
 },
 "slot": {
  "starter": "Inicio",
  "main": "Actividad principal",
  "speaking": "Conversación",
  "resource": "Hoja / recurso",
  "exit": "Ticket de salida"
 },
 "rt": {
  "own_work": "Obra propia",
  "cc_by": "CC BY",
  "cc0": "CC0",
  "public_domain": "Dominio público",
  "licensed_for_reuse": "Licencia de reutilización"
 },
 "tab": {
  "library": "Biblioteca",
  "create": "Crear",
  "packs": "Paquetes",
  "substitute": "Paquete sustituto",
  "review": "Revisión"
 },
 "ck": {
  "language_correct": "Idioma correcto",
  "cefr_fit": "Nivel MCER adecuado",
  "objective_clear": "Objetivo claro",
  "meaningful_language_use": "Exige uso significativo de la lengua",
  "learner_instructions": "Instrucciones del alumno claras",
  "teacher_instructions": "Instrucciones docentes claras",
  "cultural_credibility": "Culturalmente creíble",
  "stereotype_risk": "Sin estereotipos",
  "age_context": "Adecuado a edad y contexto",
  "copyright_provenance": "Derechos / procedencia OK",
  "privacy": "Sin datos personales",
  "cards_accurate": "Tarjetas correctas",
  "roles_balanced": "Roles equilibrados",
  "data_plausible": "Datos plausibles",
  "answer_key_correct": "Clave correcta",
  "puzzle_solvable": "Puzle resoluble",
  "text_level": "Texto del nivel adecuado",
  "authentic_format": "Formato auténtico",
  "realistic_form": "Formulario realista"
 }
};
export default al;
